module.exports = __webpack_public_path__ + "img/smart-luck-icon.106cf4a9.svg";